module.exports = __webpack_public_path__ + "img/promotion.d938f13d.svg";